import PropTypes from 'prop-types';

import Presenter from 'utils/PropTypesPresenter';

export default new Presenter({
  id: PropTypes.number,
  fileUrl: PropTypes.string,
  fileName: PropTypes.string,
  dataset: PropTypes.string,
  createdAt: PropTypes.string,
  state: PropTypes.string,
  user: PropTypes.string,
});
